/**
 * Epoch unificado: max(flush lock epoch, leader epoch).
 */

import type { OperationContext } from './ownershipGate';
import { getFlushLockEpoch } from './distributedLock';
import { getLeaderEpochFromStorage } from './distributedRecovery';

export function getCoordinationEpoch(): number {
  return Math.max(getFlushLockEpoch(), getLeaderEpochFromStorage());
}

export function getEpochAtAcquire(): number {
  return getCoordinationEpoch();
}

export function isEpochStale(ctx: Pick<OperationContext, 'epochAtAcquire'>): boolean {
  return getCoordinationEpoch() > ctx.epochAtAcquire;
}
